import { render, staticRenderFns } from "./verification-success.vue?vue&type=template&id=68027974"
import script from "./verification-success.vue?vue&type=script&lang=js"
export * from "./verification-success.vue?vue&type=script&lang=js"
import style0 from "./verification-success.vue?vue&type=style&index=0&id=68027974&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports